import { Box, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { BulkSelected, Select, StudentCustomIdsPaster } from "components";
import { BulkSelectedItemErrors, Student, StudentBulkCreateServicesResource, StudentGroup } from "generated/openApi";
import ApiService from "services/apiService";
import { useState } from "react";

export const SelectedStudents = (props: {
  students: Map<number, Student>;
  setStudents: (value: Map<number, Student>) => void;
  resource: StudentBulkCreateServicesResource;
  errors: BulkSelectedItemErrors[];
  setErrors: (value: BulkSelectedItemErrors[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();

  const [customIds, setCustomIds] = useState<string[]>([]);

  const getItemLabel = (student: Student) => (
    <Stack>
      <Typography>
        {student.lastName}, {student.firstName}
      </Typography>
      <Typography variant="caption" lineHeight="100%">
        {student.customId1}
      </Typography>
    </Stack>
  );

  return (
    <Box ref={breakpointsRef}>
      <BulkSelected
        label="Student"
        items={props.students || []}
        setItems={(value) => props.setStudents(value)}
        getItemLabel={getItemLabel}
        errors={props.errors}
        setErrors={props.setErrors}
        quickAdd={
          <Grid container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
              <Select
                label="Add by Name"
                value={undefined as unknown as Student}
                onChange={(e, value) => {
                  const newStudents = new Map(props.students);
                  newStudents.set(value.id, value);
                  props.setStudents(newStudents);
                }}
                fetchFunction={(searchString) => ApiService.search.students(searchString)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionDisabled={(option) => props.students.has(option.id)}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {getItemLabel(option)}
                  </Box>
                )}
                getOptionLabel={() => ""}
              />
            </Grid>

            <Grid item xs={smallFieldBreakpoints}>
              <Select
                label={`Add by Group`}
                value={undefined as unknown as StudentGroup}
                onChange={(e, value) => {
                  ApiService.students.getGroupStudents(value.id).then((response) => {
                    const newStudents = new Map(response?.map((x) => [x.id, x]));
                    props.students.forEach((student, key) => newStudents.set(key, student));
                    props.setStudents(newStudents);
                  });
                }}
                options={props.resource.studentGroups}
                getOptionDisabled={(option) => props.students.has(option.id)}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.name}
                  </Box>
                )}
                getOptionLabel={(option) => ""}
              />
            </Grid>

            <Grid item xs={fullFieldBreakpoints}>
              <StudentCustomIdsPaster
                value={customIds}
                onChange={(customIdTypeId, newIds) => {
                  setCustomIds(newIds);
                }}
                onAdd={(customIdTypeId, newIds) => {
                  if (customIdTypeId && newIds.length > 0) {
                    ApiService.students
                      .getByCustomIds({ customIdTypeId, customIds: newIds })
                      .then((response) => {
                        const newStudents = new Map(response.map((x) => [x.id, x]));
                        props.students.forEach((student, key) =>
                          newStudents.set(key, student)
                        );
                        props.setStudents(newStudents);
                        setCustomIds(newIds);
                      });
                  }
                }}
              />
            </Grid>
          </Grid>
        }
      />
    </Box>
  );
};
